/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

 
define([
  "backbone",
  "underscore"
], function(
  Backbone,
  _
) {
    var TreeCollection = Backbone.Collection.extend({

      initialize: function (models, options) {
        this.delegate = options.delegate;

        this.listenTo(this.delegate, "all", this.reset);
      },

      reset: function () {
        var that = this,
            attributes = this.delegate && this.delegate.get(),
            toRemove = this.pluck("id"),
            models;

        _.forEach(attributes, function (model, id) {
          model.id = id;
          models = that.add(model, { merge: true });
          toRemove = _.without(toRemove, id);
        });

        models = this.remove(toRemove);
        return models;
      }
    });

  return TreeCollection;
});
